export class Settings {
    lastInvitationTimestamp: number;
}
